import { useCallback, useEffect, useState } from "react";
import { Modal } from "antd";
import { endCall, checkSession, startCall } from "../apis/callingAPis";
import { useAuth } from "../context/authContext";
import { useConversation } from "@11labs/react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const CallModal = ({
  iscallModalOpen,
  showreviewModal,
  showcallModal,
  timer,
  setTimer,
}) => {
  const {
    email,
    username,
    agenid,
    customerId,
    sessionid,
    clientSecret,
    setAuthData,
  } = useAuth();
  const [connectionStatus, setConnectionStatus] = useState("Connecting...");
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [stream, setStream] = useState(null);
  const conversation = useConversation({
    onConnect: () => {
      console.log("Connected");
      setConnectionStatus("Connected");
      setIsTimerActive(true);
    },
    onDisconnect: () => {
      console.log("Disconnected");
      setConnectionStatus("Disconnected");
      setIsTimerActive(false);
    },
    onMessage: (message) => console.log("Message:", message),
    onError: (error) => console.error("Error:", error),
  });

  // Start the conversation and handle microphone permissions
  const startConversation = useCallback(async () => {
    const res = await startCall(username, email, agenid, customerId);

    setAuthData({
      username: username,
      email: email,
      sessionid: res,
      agenid: agenid,
      customerId: customerId,
      clientSecret: clientSecret,
    });

    try {
      const AgentId = "3X5LBEVlKcVj7sjX4bnS";
      console.log("AgentId", agenid);
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });
      console.log(mediaStream);
      setStream(mediaStream);

      const ress = await conversation.startSession({
        agentId: AgentId,
      });
      console.log("ress", ress);
    } catch (error) {
      console.error("Failed to start conversation:", error);
    }
  }, [conversation, agenid]);

  const stopConversation = useCallback(async () => {
    await conversation.endSession();
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    await endCall(email, sessionid);
    const hours = Math.floor(timer / (60 * 60));
    const minutes = Math.floor((timer % (60 * 60)) / 60);
    const seconds = timer % 60;
    Cookies.set("callDuration", `${hours}h ${minutes}m ${seconds}s`, {
      expires: 7,
    });
    showreviewModal();
    setConnectionStatus("Connecting...");
    setIsTimerActive(false);
  }, [conversation, showreviewModal]);

  // Timer logic
  useEffect(() => {
    let timerInterval;
    if (isTimerActive) {
      timerInterval = setInterval(() => {
        setTimer((prevTime) => prevTime + 1);
      }, 1000);
    } else if (!isTimerActive && timer !== 0) {
      clearInterval(timerInterval);
    }
    return () => clearInterval(timerInterval);
  }, [isTimerActive]);

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  };
  useEffect(() => {
    let checkSessionInterval;
    if (isTimerActive) {
      checkSessionInterval = setInterval(() => {
        checkSession(email, sessionid)
          .then((res) => {
            console.log("Session :", res.active);
            if (res.active === false) {
              stopConversation();
              toast.error("Call was ended due to payment failure.");
              clearInterval(checkSessionInterval);
            }
          })
          .catch((error) => {
            console.error("Session check error:", error);
            stopConversation();
            toast.error("Call was ended due to payment failure.");
            clearInterval(checkSessionInterval);
          });
      }, 55000); // Check every 55 seconds

      // Cleanup function to clear interval when component unmounts
      return () => clearInterval(checkSessionInterval);
    }
  }, [isTimerActive]);

  return (
    <>
      <Modal
        open={iscallModalOpen}
        onCancel={showcallModal}
        centered
        footer={null}
        className="white-call-modal"
        maskClosable={false}
        closeIcon={null}
      >
        <h5>{username}</h5>
        <img
          src="https://white-lable-frontend.s3.us-east-1.amazonaws.com/assets/icons/user.svg"
          alt="..."
          className="userImg"
        />

        {connectionStatus === "Connected" && <p>{connectionStatus}</p>}
        {/* Timer */}
        {connectionStatus === "Connected" && (
          <p className="text-white">{formatTime(timer)}</p>
        )}
        {connectionStatus === "Connecting..." && (
          <button
            className="cursor-pointer btn-secondary-main"
            onClick={startConversation}
          >
            Start Call
          </button>
        )}

        {connectionStatus === "Connected" && (
          <>
            <div className="icons">
              <img
                src="https://white-lable-frontend.s3.us-east-1.amazonaws.com/assets/icons/speaker.svg"
                alt="Speaker"
                className="cursor-pointer"
                // onClick={toggleSpeaker}
              />
              <img
                src="https://white-lable-frontend.s3.us-east-1.amazonaws.com/assets/icons/mic.svg"
                alt="Mic"
                className="cursor-pointer"
                // onClick={toggleMute}
              />
              <img
                src="https://white-lable-frontend.s3.us-east-1.amazonaws.com/assets/icons/endcall.svg"
                alt="End Call"
                className="cursor-pointer"
                onClick={stopConversation}
              />
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default CallModal;
